import { SendIcon } from 'lucide-react'

export default function EmptyState () {
  return (
    <div>
      <h1 className='mb-6 text-gray-500 body'>Enrollment rate</h1>
      <div className='grid grid-cols-4 rounded-lg border border-color-stroke-light bg-gray-100 shadow-md'>
        <div className='col-span-2 lg:col-span-1 h-full flex items-end justify-start pt-4 pr-4'>
          <div className='relative max-w-24 max-h-24'>
            <SendIcon className='absolute -top-2 -right-2 lg:w-6 lg:h-6 sm:w-5 sm:h-5 rounded-full text-white bg-gradient-to-b from-[#CFCFCF] to-[#6E6E6E] p-1 shadow-[0_0.667px_8px_0_rgba(0,0,0,0.10)]' />
            <img src={RAILS_ASSET_URL('thatch-envelope.png')} alt='Envelope' className='w-full max-w-24 max-h-24' />
          </div>
        </div>
        <div className='col-span-2 lg:col-span-3 border-l border-gray-200'>
          <div className='flex items-center gap-2 text-main body-sm h-full p-1 md:p-4 lg:p-6'>
            Complete the required onboarding tasks to start inviting your employees!
          </div>
        </div>
      </div>
    </div>
  )
}
